import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  return Cookies.get(TokenKey)
  // return "Bearer eyJhbGciOiJIUzUxMiJ9.eyJleHAiOjE2NzcwMzczNzEsInN1YiI6ImFkbWluIiwiY3JlYXRlZCI6MTY3NjQzMjU3MTc5Mn0.8oX9_xuHBcCFQGmx73EcvWGS_Sv-v9mwbL0WTz2_lEzDUz3Mc1Jd9Ki1EgW_mNq70KTSEsVpHx3eBFZI7gFU2g";
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js